import axios from "axios";
import _ from "lodash";

import { getToken, setToken } from "@/utils/cookies";
import utilsConfig from "@/utils/config";
import { eventEnum, authStateEnum } from "@/utils/enum";

const config = require("../temp/config");
const BASE_URI = `${config.sitecoreApiHost}/sitecore/api/trinity/`;
const service = axios.create();
service.defaults.headers.common["X-Intramart-Session"] = "keep";
service.defaults.headers.get.Pragma = "no-cache";
service.defaults.headers.get["Cache-Control"] = "no-cache, no-store";
export const CONTENT_TYPES = {
  json: "application/json",
  form: "application/x-www-form-urlencoded; charset=UTF-8",
  file: "multipart/form-data",
  xml: "text/xml",
};

const doError = (
  code,
  error,
  resolve,
  reject,
  path,
  sc,
  contentType,
  responseType,
  params,
  body,
  ops,
  extra,
  data
) => {
  if (code === 400) {
    // 400 error
    utilsConfig.eventEmitter.emitEvent(eventEnum.fourHundred);
  } else if (code === 401) {
    // 401 error
    return new Promise((resolve1, reject1) => {
      utilsConfig.eventEmitter.emitEvent(eventEnum.refreshToken, [
        (token) => {
          if (token) {
            resolve1(token);
          } else {
            reject1(eventEnum.refreshToken);
          }
        },
      ]);
    })
      .then(() => {
        return r(path, sc, contentType, responseType)(params, body, ops, extra);
      })
      .then((res) => {
        resolve(res);
      })
      .catch((res) => {
        if (res === eventEnum.refreshToken) {
          utilsConfig.eventEmitter.emitEvent(eventEnum.logout);
        }
        reject(res);
      });
  } else if (code === 403) {
    // 403 error
    utilsConfig.eventEmitter.emitEvent(eventEnum.forbidden);
  } else if (code === 500) {
    // 500 error
    utilsConfig.eventEmitter.emitEvent(eventEnum.internetError);
  } else if (code === 503 || code === 504) {
    // 503,504 web api error
    document.open("text/html", "replace");
    document.write(data);
    document.close();
  }
  reject(error);
};

export const r = (
  path,
  sc = true,
  contentType = CONTENT_TYPES.json,
  responseType = null
) => {
  const str = path.split(" ");
  const method = str[0];
  let url = str[1];
  if (!/^(http|https)/.test(url)) {
    if (!sc) {
      url = `${config.sitecoreApiHost}/${url}`;
    } else {
      url = BASE_URI + url;
    }
  } else if (/^~/.test(url)) {
    url = url.substr(1);
  }

  return (params, body, ops, extra) => {
    const authentication = getToken();
    if (authentication) {
      service.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${authentication.token}`;
      if (authentication.type === authStateEnum.auth0) {
        service.defaults.headers.common["key"] = authentication.accountId;
      } else {
        service.defaults.headers.common["usercd"] = authentication.accountId;
      }
    }
    if (sc) {
      params = _.merge(
        {
          sc_apikey: config.sitecoreApiKey,
        },
        params
      );
      if (method === "GET") {
        params = Object.assign(params || {}, {
          _t: new Date().getTime(),
        });
      }
    }
    const pathNames = [];
    url = url.replace(/{(\w|_)(\d|\w|_)*}/gi, (match) => {
      const pathName = match.substr(1, match.length - 2);
      if (pathNames.indexOf(pathName) === -1) {
        pathNames.push(pathName);
      }
      if (params && params[pathName]) {
        return params[pathName];
      }
      if (body && body[pathName]) {
        return body[pathName];
      }
    });
    for (let pathName of pathNames) {
      if (params && params[pathName]) {
        delete params[pathName];
      }
      if (body && body[pathName]) {
        delete body[pathName];
      }
    }

    const options = _.merge({}, ops, {
      method: method,
      url: url,
      params,
      data: body,
      headers: {},
      withCredential: true,
    });
    if (contentType) {
      options.headers["Content-Type"] = contentType;
      switch (contentType) {
        case CONTENT_TYPES.file:
          options.data = new FormData();
          for (const key in body) {
            if (Object.prototype.hasOwnProperty.call(body, key)) {
              options.data.append(key, body[key]);
            }
          }
          options.headers["X-Requested-With"] = "XMLHttpRequest";
          break;
        case CONTENT_TYPES.form:
          options.transformRequest = [
            function (data) {
              let ret = "";
              for (let it of Object.keys(data)) {
                if (ret !== "") {
                  ret += "&";
                }
                let retval = data[it] ? encodeURIComponent(data[it]) : "";
                ret += encodeURIComponent(it) + "=" + retval;
              }
              return ret;
            },
          ];
          break;
        default:
          break;
      }
    }
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const promise = new Promise((resolve, reject) => {
      options.cancelToken = source.token;
      if (responseType) {
        options.responseType = responseType;
      }
      service
        .request(options)
        .then((res) => {
          if (res.data && responseType === "blob") {
            resolve(extra ? { ...res.data, ...extra } : res.data);
          } else if (res.data.code === 200 || res.data.error === false) {
            if (res?.headers["nomura-trinity-user-identifier"]) {
              authentication.userIdentifier =
                res?.headers["nomura-trinity-user-identifier"];
              setToken(authentication);
              // 課金-ADD-START
              utilsConfig.eventEmitter.emitEvent(
                eventEnum.updateAuthentication
              );
              // 課金-ADD-END
            }
            resolve(extra ? { ...res.data.data, ...extra } : res.data.data);
          } else {
            doError(
              res.data.code,
              new Error(),
              resolve,
              reject,
              path,
              sc,
              contentType,
              responseType,
              params,
              body,
              ops,
              extra
            );
          }
        })
        .catch((res) => {
          doError(
            res?.response?.status,
            res,
            resolve,
            reject,
            path,
            sc,
            contentType,
            responseType,
            params,
            body,
            ops,
            extra,
            res?.response?.data
          );
        });
    });
    promise.abort = (msg) => {
      source.cancel(msg !== null && msg !== undefined ? msg : null);
    };
    return promise;
  };
};
